import initmixin from "@/Services/initmixin";

export default {
    // GET específico para el endpoint ordenes con filtros de fecha
    GET_TEST: async function(data) {
        let url = `/ordenes?page=${data.page}&search=${data.search}&inicio=${data.inicio}&fin=${data.fin}`;
        return initmixin.formatrespuesta('get', data, url, true);
    }
}
